module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/array/from.js
// module id = ./node_modules/babel-runtime/core-js/array/from.js
// module chunks = 0 1 2